import { ui } from "../../../../../../../interfaces/interfaces";

export const addAddress = (type: string) => {
  const problemTabsList = JSON.parse(ui.ProblemTabsList);
  if (problemTabsList.length === 1) {
    type === "landlord" && (ui.ProblemTabsList = JSON.stringify([...problemTabsList, { label: "Landlord", name: "landlord" }]));
    type === "other" && (ui.ProblemTabsList = JSON.stringify([...problemTabsList, { label: "Related", name: "related" }]));
  }
  if (type === "other" && problemTabsList.length === 2) {
    ui.ProblemTabsList = JSON.stringify([
      { label: "Property", name: "property" },
      { label: "Related", name: "related" },
    ]);
  }
};

export const removeAddress = () => {
  ui.ProblemActiveAddressTab = 0;
  ui.ProblemTabsList = JSON.stringify([{ label: "Property", name: "property" }]);
};
